var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-data-views"},[_c('reports-content',_vm._b({key:_vm.rndKey},'reports-content',_vm.dataProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }